import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, Navigate} from "react-router-dom";
import PersistentDrawerLeft from "../../components/navMenu/NavMenu";
import firebase from '../../config/firebase';
import DataPaymentTable from "../../components/Data-payment-table/data-payment-table";
import { Button, Form, Modal, Select } from "antd";
import PaymentModal from "../../components/modal-salve-payment/modal-payment";
import { useLocation } from "react-router-dom";
import PaymentModalDespesas from "../../components/modal-salve-payment/ModalPayment";
import NewMiniDrawer from "../../components/navMenu/menu-nav";
import "./list-payment.css";
require('firebase/auth')

function PaymentListDetail(){
    const db = firebase.firestore();

    var userLogado = useSelector(state => state.usuarioLogado);
    const user = useSelector(state => state.user)

    const location = useLocation();
    const record = location.state?.record;
    const view = location?.state?.viewOnly;

    const [listPayment, setListPayment] = useState(record);
    const [selectDriver, setSelectedDriver] = useState();
    const [updatedList, setUpdateList] = useState(false);
    const [open, setOpen] = useState();

    //Abre o modal de adicionar despesas
    const onOpen = (record) => {
        setSelectedDriver(record);
        setOpen(true);
    }

    //Fecha o modal de adicionar despesas
    const onClose = () => {
        setOpen(false)
    }

    const saveProp = (result) => {
        if (result) {
            setUpdateList(true);
        }
    }
    
    const [carregando, setCarregando] = useState(1);
    
    let paymentList = [];

    useEffect(() => {

        if(userLogado > 0) {
            // if(user.perfil === "Master"){

                db.collection('payment')
                .get().then( async (result) => {
                    result.docs.forEach(doc => {

                        paymentList.push({
                            id: doc.id,
                            ...doc.data()
                        });
                    })
                    
                    setListPayment(paymentList)
                    setCarregando(0)
                }).catch(error => {
                    setCarregando(0)
                    console.log(error)
                });

            // }
        }
    },[carregando]);

    return(
        <>
            { 
                useSelector(state => state.usuarioLogado) > 0 ? 
                    <NewMiniDrawer divOpen={
                        <div className="freight-content">
                            <div className="container mb-3">
                                <div className="row">
                                    <div className="col-5">
                                        <h4>Detalhe do Pagamento</h4>
                                    </div>
                                    <div className="col-5">
                                    </div>
                                    <div className="col-2">
                                        <div className="col-md-11 control-label">
                                            {
                                                user?.permissoes?.payment?.isCreate || user?.permissoes?.pagamento?.cadastrar ? (
                                                    <Link>
                                                        <Button
                                                            onClick={() => onOpen(listPayment)}
                                                            className="add-expense-btn"
                                                        >
                                                            <span className="add-expense-btn__icon-wrap">
                                                                <img
                                                                    src="https://firebasestorage.googleapis.com/v0/b/app-fortio.appspot.com/o/files%2Fwallet-filled-money-tool%201.svg?alt=media&token=0a32098e-e995-41b0-ac88-fafcfbc0e03d"
                                                                    alt="wallet"
                                                                    className="add-expense-btn__icon"
                                                                />
                                                            </span>

                                                            <span className="add-expense-btn__label">Adicionar Despesas</span>
                                                        </Button>
                                                    </Link>
                                                )
                                                :
                                                (
                                                    ""
                                                )
                                            }
                                        </div>
                                    </div>
                                </div>        
                            </div>
                            <div>
                                <div style={{ height: 400, width: '100%' }}>
                                    <DataPaymentTable view={view} data={listPayment} updatedList={updatedList} />
                                    <PaymentModalDespesas visible={open} onClose={onClose} driverName={record} type={"Adiantamento"} onSaveResult={saveProp} />
                                </div>
                            </div>

                            
                        </div>
                }/>
                : 
                <Navigate to='/login' />
            }
        </>
    );
}

export default PaymentListDetail;